var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"elevation":_vm.elevation,"dark":_vm.dark,"color":_vm.color,"small":_vm.size === 'small',"x-small":_vm.size === 'x-small',"large":_vm.size === 'large',"x-large":_vm.size === 'x-large',"fab":""},on:{"click":() => _vm.$emit('click')}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }